module.exports = __webpack_public_path__ + "static/media/automotive-img.b0985205.jpg";